import { render, staticRenderFns } from "./CampaignSubscribersCell.vue?vue&type=template&id=636a8665&scoped=true"
import script from "./CampaignSubscribersCell.vue?vue&type=script&lang=js"
export * from "./CampaignSubscribersCell.vue?vue&type=script&lang=js"
import style0 from "./CampaignSubscribersCell.vue?vue&type=style&index=0&id=636a8665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a8665",
  null
  
)

export default component.exports